import { render, staticRenderFns } from "./ModalMedicalRecord.vue?vue&type=template&id=025d8b22&"
import script from "./ModalMedicalRecord.vue?vue&type=script&lang=js&"
export * from "./ModalMedicalRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports